/** localStorage keys for ApiKeyPortal / dashboard auth session */
export const STORAGE_KEY = 'phase2_portal_session_v1';
export const ENGINE_URL_KEY = 'phase2_engine_url_v1';
